import React, { useEffect, useContext, useState } from "react";
import Cart from "Components/CartQuote/Cart";
import useScrollToTop from "Components/Hooks/useScrollToTop";
import { useEffectOnce } from "Components/Hooks/useEffectOnce";
import { useLocation, useNavigate } from "react-router-dom";
import { APIQueryPost, APIQueryGet } from "APIMethods/API";
import DomainContext from "Context/DomainContext";
import { useDispatch, useSelector } from "react-redux";
import { ACTION_GUESTKEY, ACTION_GUESTQUOTE__DETAILS } from "Store/action";
import { getCartItems } from "Utilities";

function CartPage() {
  useScrollToTop();
  const { storeId, defaultURL } = useContext(DomainContext);
  const navigate = useNavigate();
  const token = useSelector((state) => state?.token);
  const guestKey = useSelector((state) => state?.guestKey);
  const isSessionExpired = useSelector((state) => state?.isSessionExpired);
  const customerQuoteId = useSelector((state) => state?.customerQuoteId);
  const customerId = useSelector((state) => state?.customerDetails?.id);
  const guestQuoteId = useSelector((state) => state?.guestQuoteDetails?.id);
  const location = useLocation();
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(location.search);
  const quoteId = queryParams.get("quoteId");
  const decodedQuoteId = quoteId ? atob(quoteId) : null;
  const [loadingDelete, setLoadingDelete] = useState(false);

  useEffectOnce(() => {
    const resolution = `${window.screen.width} x ${window.screen.height}`;
    const postUrl = `analytical_info/action/store`;
    const request = new XMLHttpRequest();
    request.open("POST", postUrl, true);
    request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
    request.send(`resolution=${resolution}`);
  });

  // Store decoded quote ID in localStorage if it exists
  useEffect(() => {
    if (decodedQuoteId) {
      localStorage.setItem("reloadify_quoteId", decodedQuoteId);
    }
  }, [decodedQuoteId]);

  const AbandantCartFetch = (targetMaskedId, validUser) => {
    let url = validUser === "customer" ? `${defaultURL}/customer/abandonedcart` : `${defaultURL}/abandonedcart`;
    APIQueryPost({
      isLoader: true,
      loaderAction: (bool) => {},
      axiosData: {
        url: url,
        method: "post",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        paramsData: {
          sourceMaskedId: decodedQuoteId,
          targetMaskedId: targetMaskedId,
          storeId: storeId,
        },
      },
      getStatus: (res) => {},
      setGetResponseData: (res) => {
        if (res?.data) {
          getCartItems(
            dispatch,
            setLoadingDelete,
            customerQuoteId ? customerQuoteId : guestQuoteId,
            customerId,
            () => {},
            defaultURL,
            storeId,
            token,
            navigate,
            isSessionExpired
          );
        }
      },
    });
  };

  const createQuoteId = (key) => {
    const guestQuoteDetailsOptions = {
      isLoader: true,
      loaderAction: (bool) => {},
      setGetResponseData: (resData) => {
        if (resData?.status === 200) {
          dispatch(ACTION_GUESTQUOTE__DETAILS(resData?.data));
          dispatch(ACTION_GUESTKEY(key));
          AbandantCartFetch(key, "guest");
        }
      },
      getStatus: (res) => {
        if (res?.status !== 200) {
        }
      },
      axiosData: {
        url: `${defaultURL}/guest-carts/${key}`,
      },
    };
    APIQueryGet(guestQuoteDetailsOptions);
  };

  useEffect(() => {
    if (decodedQuoteId && customerId === undefined && guestKey === "") {
      const guestKeyOptions = {
        isLoader: true,
        loaderAction: (bool) => {},
        setGetResponseData: (resData) => {
          if (resData?.status === 200) {
            createQuoteId(resData?.data);
          }
        },
        getStatus: (res) => {
          if (res?.status !== 200) {
          }
        },
        axiosData: {
          url: `${defaultURL}/guest-carts`,
        },
      };
      APIQueryPost(guestKeyOptions);
    } else if (
      (decodedQuoteId && customerId === undefined && guestKey !== "") ||
      (decodedQuoteId && customerId !== undefined && guestKey === "" && parseInt(decodedQuoteId) !== customerQuoteId)
    ) {
      AbandantCartFetch(customerQuoteId ? customerQuoteId : guestKey, customerQuoteId ? "customer" : "guest");
    }
  }, [decodedQuoteId]);

  return (
      <Cart />
  );
}

export default CartPage;
